import { variantIconColorMap, sizeToIconSizeMap } from '@primitives/SplitButton/constants';
import cx from 'classnames';

import { IconSize } from '@icons/types';
import { ButtonSize } from '@primitives/Button/types';

import { SplitButtonVariant } from '@primitives/SplitButton/types';

import styles from '@primitives/SplitButton/SplitButton.module.scss';

export const getIconBtnSizeStyle = (size: ButtonSize) => {
    return cx(styles[size]);
};

export const getIconBtnVariantStyle = (variant: SplitButtonVariant) => {
    return styles[variant];
};

export const getIconColor = (variant: SplitButtonVariant) => {
    return variantIconColorMap[variant];
};

export const getIconSize = (size: ButtonSize): IconSize => {
    return sizeToIconSizeMap[size];
};
